// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BuyerDashboardModule } from '../buyer-dashboard/buyer-dashboard.module';
import { MaterialModule } from '../shared/material.module';
import { SharedModule } from '../shared/shared.module';
import { HowToComponent } from './how-to/how-to.component';
import { NewUserRoutingModule } from './new-user-routing.module';
import { SetUpComponent } from './set-up/set-up.component';
import { WelcomeToDDJComponent } from './welcome-to-ddj/welcome-to-ddj.component';

@NgModule({
    declarations: [HowToComponent, SetUpComponent, WelcomeToDDJComponent],
    imports: [CommonModule, MaterialModule, NewUserRoutingModule, ReactiveFormsModule, RouterModule, SharedModule],
})
export class NewUserModule {}
